/* global ga, grecaptcha */
import axios from 'axios';
import { setCarList } from './actions';
import { host } from './libs';
// const DEV_MODE = window.location.hostname !== 'pages.toyota.ru';

export const reCAPTCHA_SITE_KEY = '6Lc_I68UAAAAAImrMUDkhX7yhWoq-a2tAoUX5EOp';

export function makeRequest(params, then, error) {
  axios(params).then((result) => {
    if (then) then(result);
  }).catch((r) => {
    if (error) error(r);
  });
}

export const loadCarList = (dispatcher) => {
  const url = `${host}/graphql?query={
    car_models(car_brand_id: 109) {
      id
      name
      brochure_form_sort_order
      brochure_car_model_image
      brochure_model_url_part
      pricelist_pdf
      brochure_pdf {
        pdf
        preview_url
      }
      accessories_pdf {
        pdf
        preview_url
      }
      brochure_custom {
        pdf
        name
        preview_url
      }
    }
  }`;

  makeRequest(
    { url },
    response => {
      const carList = response.data.data.car_models.filter(i => i.brochure_car_model_image).map(i => {
        return ({
          id: i.id,
          urlPart: i.brochure_model_url_part,
          name: i.name,
          order: i.brochure_form_sort_order,
          image: `${host}${i.brochure_car_model_image}`,
          brochures: [
            {
              type: 'brochure',
              title: 'Брошюра',
              value: i.brochure_pdf && i.brochure_pdf.pdf,
              preview: i.brochure_pdf && i.brochure_pdf.preview_url,
            },
            {
              type: 'custom',
              title: i.brochure_custom && i.brochure_custom.name,
              value: i.brochure_custom && i.brochure_custom.pdf,
              preview: i.brochure_custom && i.brochure_custom.preview_url,
            },
            {
              type: 'accessories',
              title: 'Брошюра об аксессуарах',
              value: i.accessories_pdf && i.accessories_pdf.pdf,
              preview: i.accessories_pdf && i.accessories_pdf.preview_url,
            },
            {
              type: 'priceList',
              title: 'Спецификация',
              value: i.pricelist_pdf,
              preview: i.pricelist_pdf && `${host}${i.pricelist_pdf}`,
            },
          ].filter(item => item.title && item.value && item.preview),
        });
      }).filter(i => i.brochures.length).sort((a, b) => a.order - b.order);
      dispatcher(setCarList(carList));
    },
    () => {}
  );
};

export const submitForm = (data, successCallback, errorCallback) => {
  const url = `${host}/graphql?query=mutation{brochure_form(` +
    'name:"' + encodeURIComponent(data.name) + '",' +
    'email:"' + data.email + '",' +
    'brochure_links:[' + data.brochures.map(i => `"${i}"`) + ']' +
    'news_subscription:' + data.news_subscription +
  '){id}}';

  const axiosParams = {
    url,
  };

  const googleClient = window.ga && ga.getAll()[0];

  const googleClientId = googleClient && googleClient.get('clientId');

  if (googleClientId) {
    axiosParams.headers = { 'G-Client-ID': googleClientId };
  }

  const makeRequestWithRecaptchaToken = (gRecaptchaToken) => {
    axiosParams.headers = {
      ...axiosParams.headers,
      'G-Recaptcha-Token': gRecaptchaToken,
      'G-Recaptcha-Action': 'brochures',
    };

    makeRequest(
      { ...axiosParams },
      response => {
        if (
          response.data && response.data.data &&
          response.data.data.brochure_form && response.data.data.brochure_form.id
        ) {
          const id = response.data.data.brochure_form.id;

          const rtbHouse = document.createElement("iframe");
          rtbHouse.src = `https://creativecdn.com/tags?id=pr_6gIZcTvVsLAaOHzjlhUy_orderclick3_1_form-${id}_${id}&cd=default`;
          rtbHouse.width = '1';
          rtbHouse.height = '1';
          rtbHouse.style.display = 'none';
          document.body.appendChild(rtbHouse);

          successCallback();
        }

        if (response.data.errors) {
          errorCallback();
        }

      },
      () => {
        errorCallback();
      }
    );
  };

  if (window.grecaptcha && window.grecaptcha.execute) {
    grecaptcha.execute(reCAPTCHA_SITE_KEY, {action: 'brochures'})
      .then(
        token => makeRequestWithRecaptchaToken(token),
        () => makeRequestWithRecaptchaToken('no-token'),
      );
  } else {
    makeRequestWithRecaptchaToken('no-token');
  }
};



// WEBPACK FOOTER //
// ./src/api.js